import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { sessionStore } from 'src/store/sessionStore';
import { useGetTrainerSchedule } from 'src/api/queries/useGetTrainerSchedule';
import {
  DAYS_CONFIG,
  DEFAULT_WEEKLY_SCHEDULE,
  TimeSlot,
  WeeklySchedule,
} from '../../../../Schedule/utils/timezoneUtils';
import { ReactComponent as EditIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/profile/components/edit.svg';
import './ScheduleAvailabilitySection.scss';

export const ScheduleAvailabilitySection: FC = () => {
  const navigate = useNavigate();
  const { currentUser } = sessionStore();
  const uid = currentUser?.uid;

  const { data: scheduleData } = useGetTrainerSchedule(uid);

  const timezone = scheduleData?.data?.timezone || currentUser?.timezone || 'Not configured';

  const weeklySchedule: WeeklySchedule | undefined =
    scheduleData?.data?.weekly_schedule || currentUser?.weekly_schedule;

  const handleEditClick = () => {
    navigate('/onboarding-trainer/dashboard/profile/schedule');
  };

  return (
    <div className="profile-section schedule-availability-section">
      <div className="section-header align-items-center">
        <h2>Schedule & Availability</h2>
        <div className="header-actions">
          <button className="edit-btn" onClick={handleEditClick} aria-label="Edit Schedule">
            <EditIcon />
          </button>
        </div>
      </div>

      <div className="schedule-overview-content">
        <div className="timezone-row">
          <span className="tz-label">Timezone:</span>
          <span className="tz-val">{timezone}</span>
        </div>

        <div className="days-overview-grid">
          {DAYS_CONFIG.map(({ key, label }) => {
            const dayData =
              weeklySchedule && weeklySchedule[key]
                ? weeklySchedule[key]
                : DEFAULT_WEEKLY_SCHEDULE[key];
            const isEnabled = dayData?.enabled;
            const slots = dayData?.slots || [];

            return (
              <div key={key} className={`day-overview-card ${!isEnabled ? 'disabled' : ''}`}>
                <div className="day-card-header">
                  <span className="day-name">{label}</span>
                  <span className={`status-pill ${isEnabled ? 'available' : 'unavailable'}`}>
                    {isEnabled ? 'Available' : 'Unavailable'}
                  </span>
                </div>
                <div className="day-card-slots">
                  {!isEnabled || slots.length === 0 ? (
                    <span className="no-slots">No hours scheduled</span>
                  ) : (
                    slots.map((s: TimeSlot) => (
                      <span key={s.id} className="slot-badge">
                        {s.start} — {s.end}
                      </span>
                    ))
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
